import { render, staticRenderFns } from "./DatasetManager.vue?vue&type=template&id=bcf74bb6&"
import script from "./DatasetManager.vue?vue&type=script&lang=js&"
export * from "./DatasetManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports